<template>
  <div>
    <h1>Historial de pagos</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group>
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
          <a-month-picker :disabled-date="disabledDate" @change="changePeriod" :v-model="periodo" placeholder="Seleccionar periodo" />
          <b-button @click="searchPaymentByPeriod()">Buscar</b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getPaymentsHistory"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      bordered
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No hay adeudos por mostrar"
      emptyFilteredText="No hay adeudos por mostrar"
    >
      <template v-slot:cell(amount)="row">
        {{ '$'+ row.item.amount }}
      </template>
      <template v-slot:cell(periodo)="row">
        {{ replaceMonth(row.item.periodo) }}
      </template>
      <template v-slot:cell(acciones)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          {{ row.detailsShowing ? 'Cerrar' : 'Ver'}} Detalles
        </b-button>
      </template>
      <template #row-details="row">
        <b-table
          :items="row.item.concesiones"
          small
          borderless
          :fields="[{ key: 'numConcesion', label: 'No. Concesion' }, { key: 'amount', label: 'Monto' }]"
          >
          <template v-slot:cell(amount)="row">
            {{ '$'+ row.item.amount }}
          </template>
        </b-table>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          align="right"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import moment from 'moment'
import headers from '@/config/headers.js'
const GET_PAYMENT_HISTORY = gql`
  query getPaymentsHistory($rfc: String){
    getPaymentsHistory(rfc: $rfc) {
      paidBy
      paymentDate
      periodo
      concesiones{
        numConcesion
        amount
      }
      amount
    }
  }
`
const GET_PAYMENT_HISTORY_BY_PERIOD = gql`
  query getPaymentsHistoryByPeriod($rfc: String, $periodo: String){
    getPaymentsHistoryByPeriod(rfc: $rfc periodo: $periodo){
      paidBy
      paymentDate
      periodo
      concesiones{
        numConcesion
        amount
      }
      amount
    }
  }
`
export default {
  data() {
    return {
      rfc: this.$route.params.rfc,
      fields: [
        { key: 'paidBy', label: 'Responsable de Pago' },
        { key: 'paymentDate', label: 'Fecha' },
        { key: 'amount', label: 'Monto' },
        { key: 'periodo', label: 'Periodo' },
        'acciones',
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      idConcesionAction: null,
      dataLoad: -1,
      getPaymentsHistory: [],
      periodo: {},
      months: {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre',
      },
    }
  },
  apollo: {
    getPaymentsHistory: {
      query: GET_PAYMENT_HISTORY,
      context: headers(),
      variables() {
        return {
          rfc: this.rfc,
        }
      },
      result({ data }) {
        if (data.getPaymentsHistory) {
          this.totalRows = data.getPaymentsHistory.length
        }
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    disabledDate(current) {
      return current > moment().add(1, 'days')
    },
    replaceMonth(date) {
      const month = this.months[date.split('-')[1]]
      const newDate = date.split('-')[0] + '-' + month
      return newDate
    },
    searchPaymentByPeriod() {
      if (this.periodo === '' || typeof (this.periodo) === 'object') {
        this.$apollo.queries.getPaymentsHistory.refetch()
      } else {
        this.$apollo.query({
          query: GET_PAYMENT_HISTORY_BY_PERIOD,
          context: headers(),
          variables: {
            rfc: this.rfc,
            periodo: String(this.periodo),
          },
        })
          .then(({ data }) => {
            if (data.getPaymentsHistoryByPeriod) {
              // console.log(data)
              this.getPaymentsHistory = data.getPaymentsHistoryByPeriod
              this.totalRows = data.getPaymentsHistoryByPeriod.length
            } else {
              // this.$apollo.queries.getPaymentsHistory.refetch()
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    changePeriod(event) {
      if (event) {
        this.periodo = moment(new Date(event._d)).format('YYYY-M')
      } else {
        this.periodo = ''
      }
    },
  },
  mounted() {
    // console.log(this.$route.params)
  },
}
</script>
<style scoped>
</style>
